export const GetQueryParam = (param, url) => {
    const queryParams = new URLSearchParams(url || window.location.search); // Parse query string
    return queryParams.get(param) || ""; // Return the parameter value or an empty string
};

export const toCamelCase = (str) => {
    if (!str || typeof str !== "string") {
        return ""; // Return an empty string for invalid inputs
    }
    return str
        .toLowerCase()
        .replace(/[^a-zA-Z0-9]+(.)/g, (_, char) => char.toUpperCase()); // Convert to camel case
};

export const decodeHtmlEntities = (html: string): string => {
    const txt = document.createElement('textarea');
    txt.innerHTML = html.replace(/<br\s*\/?>/gi, '');
    return txt.value;
};